export default {
  title: 'Allergènes',
  description: 'Veuillez noter que ce {{product}} peut contenir les ingrédients suivants ou leurs dérivés :',
  options: {
    dairy: 'Lait/Produits laitiers',
    eggs: 'Œufs',
    fish: 'Poisson',
    gluten: 'Gluten',
    mango: 'Mangue',
    peanuts: 'Arachides',
    sesame: 'Sésame',
    shellfish: 'Fruits de mer',
    soy: 'Soja',
    tree_nuts: 'Fruits à coque',
    celery: 'Céleri',
    crustaceans: 'Crustacés',
    lupin: 'Lupin',
    molluscs: 'Mollusques',
    mustard: 'Moutarde',
    nuts: 'Noix',
    sulphites: 'Sulfites',
    almonds: 'Amandes',
    barley: 'Orge',
    brazil_nuts: 'Noix du Brésil',
    cashew: 'Noix de cajou',
    hazelnuts: 'Noisettes',
    kamut: 'Kamut',
    macadamia: 'Noix de macadamia',
    oats: 'Avoine',
    pecan: 'Noix de pécan',
    pistachios: 'Pistaches',
    rye: 'Seigle',
    spelt: 'Épeautre',
    walnuts: 'Noix',
    wheat: 'Blé',
    sugared_drink: 'Boisson sucrée',
    lentils: 'Lentilles',
    queensland_nuts: 'Noix du Queensland',
  },
};
